import ForgotPassword from '../ForgotPassword.vue';
import ResetPassword from '../ResetPassword.vue';

export default [
    {
        path: '/forgotpassword',
        name: 'ForgotPassword',
        meta: { layout: 'blank' },
        component: ForgotPassword,
    },
    {
        path: '/resetpassword/:token',
        name: 'ResetPassword',
        meta: { layout: 'blank' },
        component: ResetPassword,
    }
]